import { render, staticRenderFns } from "./RatingChoices.vue?vue&type=template&id=40fc48af&scoped=true&"
import script from "./RatingChoices.vue?vue&type=script&lang=js&"
export * from "./RatingChoices.vue?vue&type=script&lang=js&"
import style0 from "./RatingChoices.vue?vue&type=style&index=0&id=40fc48af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc48af",
  null
  
)

export default component.exports